/* eslint-disable import/no-unresolved */
export default [
  {
    path: '/project/:alias/:projectAlias/insights/contributors',
    component: () => import('./pages/insights.layout.vue'),
    children: [
      {
        path: '',
        component: () => import('./pages/page-contributors.vue'),
        name: 'analytics'
      }
    ]
  }
];
